<template>
  <div style="overflow: hidden; position: relative;">
    <div class="switchBtn">
      <el-button :type="curStyle ? 'primary' : 'info'" :plain="!curStyle" @click=switchBtn(0)>未完结</el-button>
      <el-button :type="!curStyle ? 'primary' : 'info'" :plain="curStyle" @click=switchBtn(1)>已完结</el-button>
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline" ref="formInline">
      <!--      <el-form-item prop="company">
        <el-select v-model="formInline.company" placeholder="请选择" size="medium">
          <el-option v-for="item in companies" :key="item.value" :label="item.lable" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item prop="xmdddocno">
        <el-input v-model="formInline.xmdddocno" placeholder="订单单号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddseq">
        <el-input v-model="formInline.xmddseq" placeholder="项次" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddseq1">
        <el-input v-model="formInline.xmddseq1" placeholder="项序" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmddua017">
        <el-input v-model="formInline.xmddua017" placeholder="产品信息单号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="xmdaua001">
        <el-input v-model="formInline.xmdaua001" placeholder="子项目令号" clearable></el-input>
      </el-form-item>
      <el-form-item prop="pjabl003">
        <el-input v-model="formInline.pjabl003" placeholder="项目名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="createder">
        <el-input v-model="formInline.createder" placeholder="售中提报人" clearable></el-input>
      </el-form-item>
      <!--      <el-form-item prop="xmdaua001">
        <el-input v-model="formInline.xmdaua001" placeholder="子项目令号（项目编号）" clearable></el-input>
      </el-form-item>
      <el-form-item prop="pjabl003">
        <el-input v-model="formInline.pjabl003" placeholder="项目名称" clearable></el-input>
      </el-form-item> -->
      <!--      <el-form-item prop="pmaal004">
        <el-input v-model="formInline.pmaal004" placeholder="客户名称" clearable></el-input>
      </el-form-item> -->
      <!--      <el-form-item prop="xmddua017">
        <el-input v-model="formInline.xmddua017" placeholder="产品信息单号" clearable></el-input>
      </el-form-item> -->
      <el-form-item style="margin-right: 0; white-space: nowrap; width: 160px; flex: 0;">
        <el-button type="primary" @click="onSearch('search')">查询</el-button>
        <el-button type="primary" plain @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button type="info" plain @click="drawer = true">更多条件查询</el-button> -->
      </el-form-item>
    </el-form>
    <el-drawer title="更多条件查询" :visible.sync="drawer" :direction="direction" :size="220" style="position: absolute;"
      z-index="99" :modal="false" :modal-append-to-body="false">
      <div class="drawer-cont">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="formInline.user" placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="formInline.region" placeholder="活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
    <el-table :data="tableData" style="width: 100%;" max-height="570" border v-loading="loading">
      <el-table-column fixed prop="xmdddocno" label="订单单号" width="180">
      </el-table-column>
      <el-table-column prop="hXmdadocno" label="合同据点订单单号" width="230">
      </el-table-column>
      <el-table-column prop="dPmdl008" label="采购多角来源订单单号" width="230">
      </el-table-column>
      <el-table-column prop="xmddseq" label="项次" width="60">
      </el-table-column>
      <el-table-column prop="xmddseq1" label="项序" width="60">
      </el-table-column>
      <el-table-column prop="xmda002" label="业务人员">
      </el-table-column>
      <el-table-column prop="xmdadocdt" label="订单日期" width="180">
      </el-table-column>
      <el-table-column prop="xmdaua001" label="子项目令号" width="260">
      </el-table-column>
      <el-table-column prop="pjabl003" label="项目名称" width="350">
      </el-table-column>
      <el-table-column prop="pmaal004" label="客户名称" width="260">
      </el-table-column>
      </el-table-column>
      <el-table-column prop="xmdd001" label="料件编号" width="160">
      </el-table-column>
      <el-table-column prop="xmddua017" label="产品信息单号" width="190">
      </el-table-column>
      <el-table-column prop="oocql004" label="产地">
      </el-table-column>
      <el-table-column prop="xmdd005" label="订单数量">
      </el-table-column>
      <el-table-column prop="xmdd031" label="已转出通量" width="100">
      </el-table-column>
      <el-table-column prop="xmdd014" label="已转出货量(考虑销退数量)" width="190">
      </el-table-column>
      <el-table-column prop="createder" label="售中提报人" width="100">
      </el-table-column>
      <el-table-column prop="createdTime" label="提报时间" width="180">
      </el-table-column>
      <el-table-column fixed="right" label="操作" :width="statu === '0'? 130 : 80">
        <template slot-scope="scope">
          <el-button @click.native.prevent="changeRow(scope.$index, tableData)"
            :icon="statu === '0'?'el-icon-edit':'el-icon-view'" type="text">
            {{statu === '0'? '修改' : '查看'}}
          </el-button>
          <template v-if="statu === '0'">
            <el-divider direction="vertical"></el-divider>
            <el-popconfirm title="确定完结吗？" @confirm="wanjie(scope.row)">
              <el-button type="text" icon="el-icon-switch-button" slot="reference">完结</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="rows"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <el-dialog :title="(statu === '0'? '修改' : '查看') + '详情页'" :visible.sync="dialogVisible" width="80%"
      @close="handleClose" :modal-append-to-body="false" :append-to-body="true">
      <div class="cont-box">
        <p class="title">基本信息</p>
        <ul class="list-cont">
          <li>
            <label>订单编号:</label>
            <p>{{curData.xmdddocno}}</p>
          </li>
          <li>
            <label>项次:</label>
            <p>{{curData.xmddseq}}</p>
          </li>
          <li>
            <label>项序:</label>
            <p>{{curData.xmddseq1}}</p>
          </li>
          <li>
            <label>业务人员:</label>
            <p>{{curData.xmda002}}</p>
          </li>
          <li>
            <label>订单日期:</label>
            <p>{{curData.xmdadocdt}}</p>
          </li>
          <li>
            <label>物料编号:</label>
            <p>{{curData.xmdd001}}</p>
          </li>
          <li>
            <label>产品信息单号:</label>
            <p>{{curData.xmddua017}}</p>
          </li>
          <li>
            <label>订单数量:</label>
            <p>{{curData.xmdd005}}</p>
          </li>
          <li>
            <label>已转出通量:</label>
            <p>{{curData.xmdd031}}</p>
          </li>

          <li>
            <label>已转出货量(考虑销退数量):</label>
            <p>{{curData.xmdd014}}</p>
          </li>
          <li>
            <label>子项目令号:</label>
            <p>{{curData.xmdaua001}}</p>
          </li>
          <li>
            <label>产品型号:</label>
            <p>{{curData.xmdcua006}}</p>
          </li>
          <li>
            <label>品名:</label>
            <p>{{curData.imaal003}}</p>
          </li>
          <li>
            <label>规格:</label>
            <p>{{curData.imaal004}}</p>
          </li>
          <li>
            <label>标准产品名称:</label>
            <p>{{curData.rtaxuc003}}</p>
          </li>
          <li>
            <label>项目名称:</label>
            <p>{{curData.pjabl003}}</p>
          </li>
          <li>
            <label>客户名称代码:</label>
            <p>{{curData.xmda022}}</p>
          </li>
          <li>
            <label>客户名称:</label>
            <p>{{curData.pmaal004}}</p>
          </li>
          <li>
            <label>计划已提数量:</label>
            <p>{{curData.total}}</p>
          </li>
        </ul>
        <!-- <p class="title">产品项目组</p> -->
        <el-form :model="curData01" :rules="statu == 0 ? rule01 : {}" ref="curData01" class="list-cont01"
          :disabled="statu == 0 ? false:true">
          <el-form-item label="供应类型:" prop="xmdcua004">
            <el-select v-model="curData01.xmdcua004" placeholder="请选择" size="medium">
              <el-option v-for="item in supplyTypes" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司细分产品名称:" prop="xmdcua018">
            <el-input v-model="curData01.xmdcua018" placeholder="请输入" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="产地:" prop="xmddud001">
            <el-select v-model="curData01.xmddud001" placeholder="请选择" size="medium">
              <el-option v-for="item in places" :key="item.value" :label="item.lable" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划发货数量:" prop="planNum">
            <el-input v-model="curData01.planNum" placeholder="请输入" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="计划发货日期:" prop="planDate">
            <el-date-picker v-model="curData01.planDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              size="medium">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="售中提报人:" prop="createder">
            <el-input v-model="curData01.createder" placeholder="请输入" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="remark">
            <el-input v-model="curData01.remark" placeholder="请输入" size="medium" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
        <!-- <p class="title">计划调度部</p> -->
        <!-- <PlanList :planData="planData"></PlanList> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subCont('curData01')" v-if="hasAuth('sys:serve:cpSub') && statu !== '1'">
          确认（产品）</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import qs from 'qs'
  import PlanList from '../../components/PlanList.vue'

  export default {
    name: 'Serve',
    components: {
      PlanList
    },
    data() {
      var checkPlanNum = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入'))
        }
        setTimeout(() => {
          if (!Number.isInteger(value*1)) {
            callback(new Error('请输入数字值'))
          } else {
            if (value > this.curData.xmdd005 - this.curData.total) {
              callback(new Error('订单剩余数量不足'))
            } else {
              callback()
            }
          }
        }, 100)
      }
      return {
        spanArr: [],
        loading: true,
        dialogVisible: false,
        drawer: false,
        direction: 'ttb',
        activeNames: ['0'],
        formInline: {
          // company: 'DQ',
          xmdddocno: '',
          xmddseq: '',
          xmddseq1: '',
          xmddua017: '',
          xmdaua001: '',
          pjabl003: '',
          createder: '',
          // xmdaua001: '',
          // pjabl003: '',
          // xmddua017: ''
        },
        companies: [{
            value: 'DQ',
            lable: '电气'
          },
          {
            value: 'ZX',
            lable: '正信'
          },
          {
            value: 'GF',
            lable: '股份'
          }
        ],
        tableData: [],
        planData: [],
        curData: {},
        curData01: {
          xmdcua004: '',
          xmdcua018: '',
          xmddud001: '',
          planNum: '',
          planDate: '',
          createder: '',  
          remark: ''
        },
        rule01: {
          xmdcua004: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }],
          xmdcua018: [{
            // required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          xmddud001: [{
            required: true,
            message: '请输入',
            trigger: 'change'
          }],
          planNum: [{
            required: true,
            validator: checkPlanNum,
            trigger: 'blur'
          }],
          planDate: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          createder: [{
            // required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          remark: [{
            // required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },
        page: 1,
        rows: 10,
        total: null,
        supplyTypes: ['自产（合肥）', '自产（烟台）', '自产（丹阳）', '合作'],
        places: [{
            value: 'HF01',
            lable: '合肥园区'
          },
          {
            value: 'HF02',
            lable: '合肥外厂'
          },
          {
            value: 'ZX01',
            lable: '正信烟台'
          },
          {
            value: 'ZX02',
            lable: '正信东方'
          },
          {
            value: 'ZX03',
            lable: '正信长仪'
          },
          {
            value: 'HZXM',
            lable: '合作项目'
          },
          {
            value: '0',
            lable: '无'
          }
        ],
        curStyle: true,
        statu: '0',
      }
    },
    mounted() {
      this.getList()
    },
    methods: {
      getSpanArr(data) {
        // data就是我们从后台拿到的数据
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (data[i].xmdddocno === data[i - 1].xmdddocno) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
          // console.log(this.spanArr);
        }
      },
      objectSpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
          const _row = this.spanArr[rowIndex];
          const _col = _row > 0 ? 1 : 0;
          // console.log(`rowspan:${_row} colspan:${_col}`);
          return {
            // [0,0] 表示这一行不显示， [2,1]表示行的合并数
            rowspan: _row,
            colspan: _col
          };
        }
      },
      switchBtn(index) {
        if (index === 0) {
          this.curStyle = true
          this.statu = '0'
          this.getList()
        } else {
          this.curStyle = false
          this.statu = '1'
          this.getList()
        }
      },
      getList(e) {
        this.loading = true
        if (e === 'search') {
          this.page = 1
        }
        this.$axios.post('/three-week/findThreeWeekAtLocal', {
          statu: this.statu,
          current: this.page,
          size: this.rows,
          ...this.formInline
        }, {
          timeout: 15000
        }).then(res => {
          this.loading = false
          this.tableData = res.data.data.records
          this.total = res.data.data.total
          this.spanArr = []
          this.getSpanArr(this.tableData)
        }).catch(err => {
          this.loading = false
          // this.$message.error('加载失败，请稍候再试。')
        })
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      async getData() {
        await this.$axios.post('/three-week/findThreeWeek', {
          id: this.curData.id,
          xmdddocno: this.curData.xmdddocno,
          xmddseq: this.curData.xmddseq,
          xmddseq1: this.curData.xmddseq1,
        }).then(res => {
          if (res.data.data) {
            this.curData01 = res.data.data
            this.curData.total = res.data.data.total
            // this.curData02.threeWeekId = this.curData01.id
          } else {
            this.resetForm('curData01')
            this.curData01.id = this.curData.id,
            this.curData01.xmdddocno = this.curData.xmdddocno,
            this.curData01.xmddseq = this.curData.xmddseq,
            this.curData01.xmddseq1 = this.curData.xmddseq1
            this.curData01.xmdcua004 = this.curData.xmdcua004
            this.curData01.xmdcua018 = this.curData.xmdcua018
            this.curData01.xmddud001 = this.curData.oocql004
            this.curData01.planeNum = this.curData.planeNum
            this.curData01.planeDate = this.curData.planeDate
            this.curData01.createder = this.curData.createder
            this.curData01.remark = this.curData.remark
          }
        })
        this.$axios.post('/three-week/findWorkOrder', {
          xmdddocno: this.curData.xmdddocno
        }).then(res => {
          this.planData = res.data.data
        })
      },
      changeRow(index, data) {
        this.dialogVisible = true
        this.curData = data[index]
        this.getData()
      },
      onSearch(e) {
        this.getList(e)
      },
      subCont(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/three-week/save', {
              ...this.curData01,
              xmdd005: this.curData.xmdd005
            }).then(res => {
              this.dialogVisible = false
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.getList()
            })
          } else {
            return false;
          }
        });
      },
      wanjie(data) {
        this.$axios.post('/three-week/save', {
          xmdddocno: data.xmdddocno,
          xmddseq: data.xmddseq,
          xmddseq1: data.xmddseq1,
          id: data.id,
          statu: '1'
        }).then(res => {
          this.dialogVisible = false
          this.$message({
            message: '完结成功',
            type: 'success'
          })
          this.getList()
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.resetForm('curData01')
        // this.resetForm('curData02')
        // this.curData02.threeWeekId = ''
      }
    }
  }
</script>

<style scoped>
  .demo-form-inline {
    display: flex;
    justify-content: center;
  }

  .demo-form-inline>.el-form-item {
    /* flex: 1; */
  }

  .demo-form-inline>>>.el-form-item__content {
    /* width: 100%; */
  }

  .switchBtn {
    text-align: center;
    padding: 10px 0 30px;
  }

  .switchBtn .el-button {
    margin: 0;
    padding: 12px 42px;
    border-radius: 0;
  }

  .el-table {
    box-sizing: border-box;
  }

  .drawer-cont {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .el-tag {
    /* cursor: pointer; */
  }

  .el-table>>>.cell .el-button {
    padding: 0;
  }

  /*  .el-dialog__wrapper {
    height: 100%;
  }
  .el-dialog__wrapper >>> .el-dialog {
    height: 80%;
    overflow-y: auto;
  } */
  .cont-box {
    padding: 0 10px;
    height: 100%;
    overflow-y: auto;
  }

  .list-cont {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont01 {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont li {
    box-sizing: border-box;
    width: 25%;
    display: flex;
    padding: 12px 6px;
    align-items: center;
  }

  .list-cont01>div {
    width: 25%;
    display: flex;
    padding: 6px 0;
    align-items: center;
    margin-bottom: 0;
  }

  .title {
    line-height: 34px;
    background: #f9f9f9;
    text-indent: 1em;
    color: #999999;
  }

  .list-cont li>label {
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__label {
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__content {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .list-cont li>p {
    flex: 1;
    color: #323232;
    margin: 0 10px;
    min-height: 20px;
    border-bottom: 1px solid #dedede;
  }

  .list-cont li>.el-input,
  .list-cont li>.el-select,
  .list-cont li>.el-textarea {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .el-table>>>.el-table__fixed,
  .el-table>>>.el-table__fixed-right {
    bottom: 0 !important;
  }

  .el-form>>>.el-input.is-disabled .el-input__inner,
  .el-form>>>.el-textarea.is-disabled .el-textarea__inner {
    background-color: white !important;
    color: #323232 !important;
  }
</style>
